import {Injectable} from "@angular/core";
import {ServiceConfig} from "../app/services-config";
import {AuthorizedService} from "./authorized.service";
import {ResourceService} from "./resource.service";

@Injectable()

export class GroupService extends ResourceService {
  constructor(private authorizedService: AuthorizedService) {
    super(authorizedService, ServiceConfig.group.listUrl, ServiceConfig.group.detailUrl);
  }

  getTeacherId() {
    return this.authorizedService.loadAppConfig().map(data => data.teachers);
  }
}



// WEBPACK FOOTER //
// ./src/services/group.service.ts